import axios, { AxiosInstance } from 'axios'
import { decrypt } from '@/hooks/useDecryptedFromPath'
import { env } from '@/utils/env'

export function createApiClient(encryptedToken: string): AxiosInstance {
  const api = axios.create({
    baseURL: env('NEXT_PUBLIC_REST_API_URL'),
    timeout: 30000
  })

  const { token } = decrypt<{ token: string }>(encryptedToken)

  api.interceptors.request.use(config => {
    if (token) {
      config.headers = config.headers ?? {}
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  })

  return api
}
